(function () {
  var root = document.querySelector('[data-fh-software]');
  if (!root) return;
  var repo = root.dataset.repo;
  if (!repo) return;

  function mb(bytes) { return Math.round(bytes / 1048576) + ' MB'; }

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Minimal Markdown for release notes: headings, bullet lists, bold, paragraphs
  function renderNotes(md) {
    var html = '';
    var inList = false;
    md.replace(/\r/g, '').split('\n').forEach(function (line) {
      var t = line.trim();
      var bullet = /^[-*]\s+(.*)/.exec(t);
      if (bullet) {
        if (!inList) { html += '<ul>'; inList = true; }
        html += '<li>' + inline(bullet[1]) + '</li>';
        return;
      }
      if (inList) { html += '</ul>'; inList = false; }
      if (!t) return;
      var h = /^#{1,6}\s+(.*)/.exec(t);
      html += h ? '<h3>' + inline(h[1]) + '</h3>' : '<p>' + inline(t) + '</p>';
    });
    if (inList) html += '</ul>';
    return html;
  }
  function inline(s) { return escapeHtml(s).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>'); }

  fetch('https://api.github.com/repos/' + repo + '/releases/latest', { headers: { Accept: 'application/vnd.github+json' } })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (rel) {
      var assets = rel.assets || [];
      var setup = assets.filter(function (a) { return /setup.*\.exe$/i.test(a.name); })[0];
      var portable = assets.filter(function (a) { return /portable.*\.exe$/i.test(a.name); })[0];
      var version = (rel.tag_name || '').replace(/^v/i, '');

      if (setup) root.querySelector('[data-dl="setup"]').href = setup.browser_download_url;
      if (portable) root.querySelector('[data-dl="portable"]').href = portable.browser_download_url;

      var meta = root.querySelector('[data-dl-meta]');
      var parts = [];
      if (version) parts.push('Version ' + version);
      if (setup) parts.push(mb(setup.size));
      if (rel.published_at) parts.push('Released ' + new Date(rel.published_at).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }));
      parts.push('Windows 10 and 11 (64-bit)');
      meta.textContent = parts.join(' · ');

      if (rel.body && rel.body.trim()) {
        var notes = root.querySelector('[data-release-notes]');
        root.querySelector('[data-release-version]').textContent = 'version ' + version;
        root.querySelector('[data-release-body]').innerHTML = renderNotes(rel.body);
        notes.hidden = false;
      }
    })
    .catch(function () { /* buttons already point at the GitHub releases page */ });
})();
